import { useEffect, useState } from "react"
import { useFetch } from "hooks/use-new-fetch"

export function useAccountOptions(userAccount) {
  const [accounts, setAccounts] = useState([])
  const [request] = useFetch(`/account_users`)
  useEffect(() => {
    const getAccounts = async () => {
      try {
        const response = await request.get()
        setAccounts(response.data)
      } catch (error) {
        console.error(error)
        setAccounts([])
      }
    }
    if (userAccount.has_multi_account) {
      getAccounts()
    }
  }, [userAccount.has_multi_account, request])

  // Leaving canViewSettings in here even if it is not being used currently in the navigation.
  // This will be useful a bit later once we rewrite all of the account settings in react.
  return {
    accountId: userAccount.id,
    canViewSettings: userAccount.can_view_settings,
    accounts
  }
}
